@if (offerings.length || !hideWhenEmpty) {
  <div class="company-profile-offerings" [class.company-profile-offerings--wrap]="layout === 'wrap'" [class.company-profile-offerings--empty]="!offerings.length">
    <div class="company-profile-offerings__heading">
      <span class="company-profile-offerings__label" [id]="headingId">@if (iconClass) {<i class="company-profile-offerings__icon" [ngClass]="iconClass" aria-hidden="true"></i>}{{ heading }}@if (showCount && offerings.length) {<span class="company-profile-offerings__count">{{ offerings.length }}</span>}</span>
      @if (canExpand) {
        <button type="button" class="company-profile-offerings__expand" [attr.aria-expanded]="expanded" [attr.aria-controls]="listId" (click)="toggle()">
          {{ expanded ? collapseLabel : expandLabel + ' ' + offerings.length }}
          <i class="fal" [ngClass]="expanded ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
        </button>
      }
    </div>
    @if (offerings.length) {
      <div class="company-profile-offerings__list" [id]="listId" role="list" [attr.aria-labelledby]="headingId" [attr.tabindex]="layout === 'stack' ? 0 : null">
        @for (item of visibleOfferings; track $index) {
          <span class="company-profile-offerings__chip" [title]="item.label" role="listitem"><span class="company-profile-offerings__name">{{ item.name }}</span>@if (item.detail) {<span class="company-profile-offerings__detail">{{ item.detail }}</span>}</span>
        }
      </div>
    }
  </div>
}
